import React from 'react'
import "./Aircharter.css"

const Aircharter = () => {
    return (
        <div className="aircharter">
            <h3 className="aircharter-h3">Air Cargo Charter</h3>
            <p className="p-aircharter">
                We have a network of small cargo & large cargo aircrafts within the region that offers possibilities to move your urgent 
                cargoes within the great lakes region 
                (Kenya, Uganda, Tanzania, Uganda, Burundi, Rwanda, South Sudan, Democratic Republic of Congo & Somalia.)
                Additional Air Services include; Landing Permissions, Overflights, Fuel Brokerage, Hotel Bookings, 
                Crew Transport, Cargo reservations, Post Flight Confirmation of cargo uplift, and Cargo capacity sales
            </p>
        </div>  
    )
}

export default Aircharter